// src/services/notificationApi.ts

import type { NotificationListResponse, NotificationParams, NotificationReadResponse } from '../types/notification';
import { apiGet, apiPatch } from './apiUtils';

export const notificationApi = {
  getList: (params: NotificationParams = {}): Promise<NotificationListResponse> => {
    return apiGet<NotificationListResponse>('/notification', { ...params });
  },

  markAsAdminRead: (id: number): Promise<NotificationReadResponse> => {
    return apiPatch<NotificationReadResponse>(`/notification/${id}/read`);
  },
};
